module.exports = __webpack_public_path__ + "img/flag.e8186059.svg";